<template>
    <main ref="page" class="home-page">
        <hero-section />
        <featured-processes-section />
        <creditor-access-section />
        <institutional-section />
        <news-section />
    </main>
</template>

<script>
import HeroSection from '@/views/sections/HeroSection.vue';
import InstitutionalSection from '@/views/sections/InstitutionalSection.vue';
import NewsSection from '@/views/sections/NewsSection.vue';
import FeaturedProcessesSection from '@/views/sections/FeaturedProcessesSection.vue';
import CreditorAccessSection from '@/views/sections/CreditorAccessSection.vue';

export default {
    name: 'HomePage',
    components: {
        HeroSection,
        FeaturedProcessesSection,
        CreditorAccessSection,
        InstitutionalSection,
        NewsSection
    },

    data: () => ({
        revealObserver: null
    }),

    mounted() {
        this.scrollToAnchor();
        this.setupSectionReveal();
    },
    beforeDestroy() {
        if (this.revealObserver) this.revealObserver.disconnect();
    },
    watch: {
        '$route.hash': 'scrollToAnchor'
    },
    methods: {
        setupSectionReveal() {
            this.$nextTick(() => {
                const sections = Array.from(this.$refs.page.children).slice(1);

                sections.forEach((section, index) => {
                    section.classList.add('page-reveal');
                    section.style.setProperty('--reveal-delay', `${Math.min(index * 45, 140)}ms`);
                });

                if (!('IntersectionObserver' in window)) {
                    sections.forEach((section) => section.classList.add('is-visible'));
                    return;
                }

                this.revealObserver = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (!entry.isIntersecting) return;
                            entry.target.classList.add('is-visible');
                            this.revealObserver.unobserve(entry.target);
                        });
                    },
                    { threshold: 0.08, rootMargin: '0px 0px -70px' }
                );

                sections.forEach((section) => this.revealObserver.observe(section));
            });
        },
        scrollToAnchor() {
            const hash = this.$route.hash;
            if (hash) {
                this.$nextTick(() => {
                    const section = document.getElementById(hash.substring(1));
                    if (section) {
                        section.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            }
        }
    }
};
</script>
